<template>
  <div
    class="limited-time-activity"
    id="limitTimeActivity"
    v-if="showTimeAwardList.length"
  >
    <div class="header-wrap">
      <div class="title flex-center">
        {{ letter.v3LimitedTimeBenefits }}
      </div>
      <div class="header-btn" @click="showRulePopup(0)">
        <Icon class="btn-icon" name="help" />
        <span>{{ letter.v3EventRules }}</span>
      </div>
    </div>
    <div class="activity-swiper-container swiper-container">
      <div class="swiper-wrapper activity-wrap">
        <div
          class="swiper-slide activity-item shadow"
          v-for="(award, index) in showTimeAwardList"
          :key="index"
        >
          <div class="activity-icon" :style="getBackgroundStyle">
            <img
              :src="award.basic.cover"
              class="activity-img"
              alt="activity-img"
            />
          </div>
          <div class="activity-info">
            <div class="activity-content">{{ award.basic.title }}</div>
            <div
              v-show="
                award.basic.status === TIME_AWART_STATUS.UNFINISHED &&
                toDoList.includes(award.basic.taskType)
              "
              class="activity-btn flex-center"
              @click="toFinish(award)"
            >
              {{ letter.v3GoTo }}
            </div>
            <div
              v-show="
                award.basic.status === TIME_AWART_STATUS.UNFINISHED &&
                !toDoList.includes(award.basic.taskType)
              "
              class="activity-btn flex-center"
              @click="showRulePopup(index)"
            >
              {{ letter.v3ViewDetails }}
            </div>
            <div
              v-show="
                award.basic.status === TIME_AWART_STATUS.FINISHED &&
                award.basic.taskType != TIME_AWART_TYPE.REDIRECT
              "
              class="activity-btn flex-center"
              @click="toGetAward(award)"
            >
              {{ letter.v3Claim }}
            </div>
            <div
              v-show="
                award.basic.status === TIME_AWART_STATUS.FINISHED &&
                award.basic.taskType === TIME_AWART_TYPE.REDIRECT
              "
              class="activity-btn flex-center"
              @click="toFinish(award)"
            >
              {{ letter.v3GoTo }}
            </div>
            <div
              v-show="award.basic.status === TIME_AWART_STATUS.GOT"
              class="activity-btn disabled flex-center"
            >
              {{ letter.v3Completed }}
            </div>
          </div>
          <div class="activity-counter">
            <Icon class="counter-ico" name="time"></Icon>
            <span class="time">{{
              getCounterTime(award.basic.countdown)
            }}</span>
          </div>
        </div>
      </div>
      <div class="activity-pagination"></div>
    </div>
    <transition name="fade">
      <AwardRoleSelect
        :visible="visibleRoleSelect"
        v-show="visibleRoleSelect"
        @close="visibleRoleSelect = false"
        @getAward="getAward"
      ></AwardRoleSelect>
    </transition>
    <transition name="fade">
      <LimitedTimeRulePopup
        :timeAwardList="showTimeAwardList"
        :showRuleIndex="showRuleIndex"
        @onClose="visibleRulePopup = false"
        v-if="visibleRulePopup"
      ></LimitedTimeRulePopup>
    </transition>
    <PopupWindow
      v-if="visibleTipPopup"
      type="tips"
      :languages="letter"
      :content="popupTip"
      textAlign="center"
      @onConfirm="visibleTipPopup = false"
      @onCancel="visibleTipPopup = false"
    ></PopupWindow>
    <transition name="fade">
      <SharePopup
        v-if="visibleSharePopup"
        :shareLimitList="shareLimitList"
        @closeSharePopup="visibleSharePopup = false"
        @shareSuccess="shareSuccess"
      ></SharePopup>
    </transition>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Swiper from 'swiper';
import AwardRoleSelect from '@components/officialTopup/activity/AwardRoleSelect';
import LimitedTimeRulePopup from '@components/officialTopup/activity/LimitedTimeRulePopup.vue';
import SharePopup from '@components/officialTopup/activity/SharePopup.vue';
import { GET_FB_APPID } from '@store/officialTopup/index';
import {
  TIME_AWART_TYPE,
  JUMP_TYPE,
  GET_TIME_AWARD,
  TIME_AWART_STATUS,
  FINISH_REDIRECT,
  FINISH_SHARE
} from '@store/officialTopup/activity';
import { UPDATE_IS_LOGIN_POPUP } from '@store/officialTopup/login';
import product from '@mixins/officialTopup/product';
import style from '@mixins/officialTopup/style';
import { countDownTimeFormat } from '@utiles/officialStore';
import {
  OPEN_BROWSER,
  OPEN_WEBVIEW,
  sdkOpenLink
} from '@utiles/officialStore/sdkCtrl';
import {
  locationType,
  clickButton,
  timePoint
} from '@plugins/biPoint/_configWebstoreV3';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';
export default {
  name: 'limitedTimeActivity',
  mixins: [product, style],
  data() {
    return {
      swiper: null,
      //准备领奖的活动
      toGetActivity: null,
      toFinishActivity: null,
      shareLimitList: [],

      visibleSharePopup: false,
      visibleRoleSelect: false,
      visibleRulePopup: false,
      showRuleIndex: 0,
      visibleTipPopup: false,
      showMorePopup: false,
      popupTip: '',
      TIME_AWART_STATUS: TIME_AWART_STATUS,
      toDoList: [TIME_AWART_TYPE.SHARE, TIME_AWART_TYPE.REDIRECT],
      TIME_AWART_TYPE: TIME_AWART_TYPE
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      letter: state => state.letter,
      timeAwardList: state => state.activity.timeAwardList,
      isLogin: state => state.login.isLogin,
      picList: state => state.page.picList
    }),
    ...mapGetters(['showTimeAwardList']),
    getBackgroundStyle() {
      if (this.picList?.giftmissionbg) {
        return {
          backgroundImage: `url(${this.picList?.giftmissionbg})`
        };
      } else {
        return {};
      }
    },
    getCounterTime() {
      return countdown => {
        const { days, hours, minutes, seconds } =
          countDownTimeFormat(countdown);
        return `${days}d ${hours}:${minutes}:${seconds}`;
      };
    }
  },
  watch: {
    timeAwardList: {
      handler(newVal) {
        if (!newVal.length) return;
        this.$nextTick(() => {
          this.initSwiper();
        });
      }
    }
  },
  mounted() {
    this.$store.dispatch(GET_FB_APPID);
  },
  methods: {
    showTipPopup(content) {
      this.popupTip = content;
      this.visibleTipPopup = true;
    },
    toFinish(activity) {
      this.toFinishActivity = activity;
      if (!this.isLogin) {
        return this.$store.commit(UPDATE_IS_LOGIN_POPUP, true);
      }
      switch (activity.basic.taskType) {
        case TIME_AWART_TYPE.SHARE:
          // 如果是指定分享渠道，需要传入分享渠道列表
          if (activity.basic.taskDetail === 'appoint') {
            this.shareLimitList = activity.basic.shareChannelList;
          } else {
            this.shareLimitList = [];
          }
          this.visibleSharePopup = true;
          break;
        case TIME_AWART_TYPE.REDIRECT:
          this.$store.dispatch(FINISH_REDIRECT, activity.enname).then(res => {
            if (res.code === 1) {
              timePoint({
                activityName: 'go_link',
                eventValue: {
                  title: activity.basic.title,
                  link: activity.basic.redirectLink,
                  type: activity.type,
                  activityId: activity.enname
                }
              });
              activity.basic.status = TIME_AWART_STATUS.FINISHED;
              if (activity.basic.redirectType == JUMP_TYPE.SELF) {
                sdkOpenLink({
                  link: getGlobalGetGotoLink({
                    link: activity.basic.redirectLink
                  }),
                  openWay: OPEN_WEBVIEW
                });
              }
              if (activity.basic.redirectType == JUMP_TYPE.BLANK) {
                sdkOpenLink({
                  link: getGlobalGetGotoLink({
                    link: activity.basic.redirectLink
                  }),
                  openWay: OPEN_BROWSER
                });
              }
            }
          });
          break;
        default:
          break;
      }
    },
    showRulePopup(index) {
      this.showRuleIndex = index || 0;
      this.visibleRulePopup = true;
    },
    shareSuccess(name) {
      const enname = this.toFinishActivity?.enname;
      if (!enname) return;
      this.$store.dispatch(FINISH_SHARE, enname).then(res => {
        if (res.code === 1) {
          this.toFinishActivity.basic.status = TIME_AWART_STATUS.FINISHED;
          this.showTipPopup(this.letter.v3ShareSuccess);
        } else {
          this.showTipPopup(`[${res.code}]${this.letter.v3ShareFailure}`);
        }
      });
    },
    initSwiper() {
      try {
        this.swiper && this.swiper.destroy();
        this.swiper = new Swiper('.activity-swiper-container', {
          direction: 'horizontal',
          slidesPerView: 'auto',
          spaceBetween: 40,
          pagination: {
            el: '.activity-pagination',
            clickable: true
          },
          effect: 'slide',
          observer: true,
          observeParents: true
        });
      } catch (error) {
        console.error(error);
      }
    },
    toGetAward(activity) {
      this.toGetActivity = activity;
      this.visibleRoleSelect = true;
    },
    async getAward(role) {
      const res = await this.$store.dispatch(GET_TIME_AWARD, {
        name: this.toGetActivity.enname,
        ...role
      });
      if (res.code === 1) {
        this.toGetActivity.basic.status = TIME_AWART_STATUS.GOT;
        this.showTipPopup(this.letter.v3RewardClaimed);
      } else {
        this.showTipPopup(`[${res.code}]${this.letter.v3RewardClaimFailed}`);
      }
      this.visibleRoleSelect = false;
    }
  },
  components: {
    AwardRoleSelect,
    LimitedTimeRulePopup,
    SharePopup
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopup/_dimen.scss';
.limited-time-activity {
  position: relative;
  width: 100%;

  .header-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #333333;
    line-height: 1.1;
    .title {
      white-space: normal;
    }
    .header-btn {
      display: flex;
      align-items: center;
      font-size: 24px;
      white-space: nowrap;
      cursor: pointer;

      .btn-icon {
        width: 26px;
        height: 26px;
      }
    }
  }

  .activity-swiper-container {
    position: relative;
    text-align: center;
    margin: -10px;
    padding: 10px 10px 40px;

    .activity-pagination {
      position: absolute;
      bottom: 10px;
    }
    ::v-deep .swiper-pagination-bullet {
      width: 16px;
      height: 16px;
      background: #999999;
      &.swiper-pagination-bullet-active {
        background: $themeColor;
      }
    }
  }
  .activity-wrap {
    display: flex;

    .activity-item {
      position: relative;
      flex-shrink: 0;
      width: 315px;
      height: auto;
      background-color: #fff;
      border-radius: 20px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .activity-counter {
        position: absolute;
        top: 10px;
        left: 10px;
        padding: 0 10px;
        line-height: 1.5;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        border-radius: 16px 0 16px 0px;
        background-color: rgb(0, 0, 0, 0.15);
        .counter-ico {
          flex-shrink: 0;
          width: 24px;
          height: 24px;
          margin-right: 10px;
          color: #ffffff;
        }
        .time {
          word-break: break-word;
          color: #ffffff;
          font-size: 20px;
          text-align: start;
        }
      }

      .activity-info {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 20px;

        .activity-content {
          line-height: 1.2;
          font-size: 20px;
          word-break: break-word;
          overflow: hidden;
          text-overflow: ellipsis;
          color: $commodityNameColor;
          //超出三行显示省略号
          -webkit-line-clamp: 3;
          display: -webkit-box;
          -webkit-box-orient: vertical;
        }
        .activity-btn {
          margin-top: 40px;
          width: 224px;
          padding: 15px 20px;
          background-color: $themeColor;
          border-radius: 9px;
          font-size: 24px;
          line-height: 1.1;
          color: #ffffff;
          cursor: pointer;

          &.disabled {
            filter: grayscale(100%);
            cursor: not-allowed;
          }
        }
      }
    }
  }
}

.activity-icon {
  position: relative;
  width: 100%;
  height: 190px;
  background-repeat: no-repeat;
  background-size: 100% auto;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 20px 20px 0 0;

  .activity-img {
    position: absolute;
    cursor: pointer;
    height: 110px;
    max-width: 90%;
  }
}

@media screen and (orientation: landscape) {
  .limited-time-activity {
    margin-bottom: 10px;

    .header-wrap {
      .header-btn {
        font-size: 20px;

        .btn-icon {
          width: 26px;
          height: 26px;
        }
      }
    }
    .activity-wrap {
      .activity-item {
        width: 345px;
      }
    }
  }
}
</style>
